import colors from "app/colors";
import { UserFragment, UserRoleType } from "gql/graphql";
import { CALLOUT_KEY } from "modules/utils/Constants";
import { highlightText } from "./quill-highlight-text";

export const renderQuillUserMention = (
  user: UserFragment,
  searchTerm: string,
) => {
  let color = colors.blue;
  let callout = `${CALLOUT_KEY}${user.callout}`;

  if (user.roleType === UserRoleType.Email) {
    color = colors.blueGreen;
    callout = user.email ?? "";
  }

  const wrapper = document.createElement("div");
  wrapper.style.display = "flex";
  wrapper.style.alignItems = "center";
  wrapper.style.gap = "8px";

  const img = document.createElement("img");
  img.src = user.cloudfrontAvatarUrl ?? "";
  img.alt = user.callout ?? "";
  img.style.width = "32px";
  img.style.height = "32px";
  img.style.borderRadius = "50%";
  img.style.objectFit = "cover";
  img.style.flexShrink = "0";

  // Fallback if no avatar
  if (!user.cloudfrontAvatarUrl) {
    const initials = document.createElement("div");
    initials.textContent =
      `${user.firstName?.[0] ?? ""}${user.lastName?.[0] ?? ""}`.toUpperCase();
    initials.style.width = "24px";
    initials.style.height = "24px";
    initials.style.borderRadius = "50%";
    initials.style.backgroundColor = colors.gray20;
    initials.style.color = colors.grayMain;
    initials.style.display = "flex";
    initials.style.alignItems = "center";
    initials.style.justifyContent = "center";
    initials.style.fontSize = "10px";
    initials.style.fontWeight = "600";
    initials.style.flexShrink = "0";
    wrapper.appendChild(initials);
  } else {
    wrapper.appendChild(img);
  }

  const textElement = highlightText(callout, searchTerm);
  textElement.style.fontStyle = user.active ? "normal" : "italic";
  textElement.style.color = color;
  textElement.style.fontWeight = "500";
  textElement.style.fontSize = "14px";
  textElement.style.opacity = user.active ? "1" : "0.6";

  wrapper.appendChild(textElement);

  return wrapper;
};
